import { UserGuide, UserGuideMetadata } from "types/generated";

export const parseMinutes = (minutes: number) => {
  if (minutes < 60) {
    return `${minutes} minutes`;
  }

  return `${Math.round(minutes / 60)} hours`;
};

export const collectGroupTimeToComplete = (
  group: {
    chapters: Array<{
      guides: Array<
        Pick<UserGuide, "id"> & { metadata: Pick<UserGuideMetadata, "minutesToComplete"> }
      >;
    }>;
  },
  completedUserGuideIds: string[]
) => {
  return parseMinutes(
    group.chapters
      .flatMap((chapter) => chapter.guides)
      .reduce((acc, guide) => {
        if (completedUserGuideIds.includes(guide.id)) {
          return acc;
        }
        return acc + guide.metadata.minutesToComplete;
      }, 0)
  );
};
